import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { TotalCall, TotalCallQueryInput } from '@/models/callLog';

export const fetchTotalCallsFromPartnerUsers = async ({ partnerId, startDate, endDate }: TotalCallQueryInput): Promise<TotalCall[]> => {
  const response = await queryExecute({
    variables: {
      partnerId,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query TotalCallsFromPartnerUsers($partnerId: Float!, $startDate: String!, $endDate: String!) {
        totalCallsFromPartnerUsers(partnerId: $partnerId, startDate: $startDate, endDate: $endDate) {
          phoneNumber
          firstName
          lastName
          count
        }
      }
    `),
  });

  return response.data.totalCallsFromPartnerUsers;
};
